import { LOGIN_TYPE } from './loginEnums';
import { LoginOption } from './loginInterfaces';

export const defaultEmailOption: LoginOption = {
  option: LOGIN_TYPE.EMAIL,
  default: true,
  subFlow: undefined,
};

export const phoneNumberOption: LoginOption = {
  option: LOGIN_TYPE.PHONE,
  default: false,
  subFlow: undefined,
};
